import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import MessageCard from './MessageCard';
import { IMessage } from 'models';
import { User } from 'models/User';
import { updateLiveStreamSettings } from 'store/reducers/livestreamSettings';
import session from 'store/reducers/session';
import { UserInfoMapperSocketHandler } from 'utils/UserInfoMapper';
import { socketContextType } from 'index';
import SocketContext from 'socket-context';
import { validateAndCreateSocketIfExist } from 'utils/SocketValidator';
import ChatService from 'services/Chat';
import moment from 'moment';
import { chatParticipantType } from 'types/Constants';
import { createChat } from 'store/reducers/chat';
import ChatInputs from './ChatInputs';
import PrivateChatInput from './PrivateChatInput';
import axiosInstance from 'config/axios';

interface ChatAreaProps {
  animate: string;
  room_id: string;
  // getChat: (roomId: string) => void;
  // messageList: IMessage[];
  // traineeId: number;
  isPrivateChat: boolean;
  userData: any;
  itemData: any;
}

const ChatArea: React.FC<ChatAreaProps> = ({ animate, isPrivateChat, userData, itemData, room_id }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch<AppDispatch>();
  const [previousMessageCount, setPreviousMessageCount] = useState(0);
  // const [replyTo, setReplyTo] = useState<any | null>(null);
  const roomId = useSelector((state: RootState) => state.live.settings.roomId);
  const traineeId = useSelector((state: RootState) => state.auth.user.id);
  const messageList: any = [];
  const session_id = useSelector((state: RootState) => state.live.settings.roomId);
  const receiverData = userData;
  const senderData: any = useSelector((state: any) => state.live.settings.participantData);
  const profileData = useSelector((state: any) => state.auth.user as User);
  let _userName = itemData?.users?.filter((x: any) => x?.id != senderData?.id)?.map((y) => y?.fullname || y?.name)
  let userName = _userName?.toString();
  const participants = useSelector((state: any) => state?.session?.sessionData?.batch?.participants);
  let _participantData = participants?.filter((x: any) => x?.email?.toLowerCase() == userData.email.toLowerCase());
  let participantData = _participantData?.length > 0 ? _participantData[0] : {};
  let userInfoHandler = new UserInfoMapperSocketHandler();
  const socketList: socketContextType[] = useContext(SocketContext);
  const [messageBox, setMessageBox] = useState<any>([]);
  const messageRef = useRef<any>();
  messageRef.current = messageBox;
  const chatService = new ChatService();
  const [previousMessageBoxLength, setPreviousMessageBoxLength] = useState(0);
  const user = useSelector((state: RootState) => state.auth.user as User);

  useEffect(() => {
    dispatch(
      updateLiveStreamSettings({
        sessionData: participantData
      })
    )
    init();
  }, [])
  const sessionData: any = useSelector((state: any) => state.live.settings.sessionData);

  const init = async () => {
    if (room_id) {
      const room_idx = room_id;
      userInfoHandler = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
      getPreviousMessages(room_idx);
    } else {
      const room_idx = senderData?.id < receiverData?.id ? senderData?.id + "_" + receiverData?.id : receiverData?.id + "_" + senderData?.id;
      userInfoHandler = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
      getPreviousMessages(room_idx);
    }
  }
  const getPreviousMessages = async (room_id: any) => {
    let request = {
      room_id: room_id,
      session_map_id: session_id
    }
    chatService.getChatsUsingRoomId(room_id, session_id).then((res: any) => {
      if (res && typeof res == "object") {
        setMessageBox(res.data);
      }
    })
  }

  const handleOnMessage = async (_data: any) => {
    let data;
    try {
      data = JSON.parse(_data);
    } catch (error) {
      console.error("Error parsing socket data:", error);
      return;
    }

    if (data.type === "chat_message" && data.sub_type === "individual") {
      if (data.chat_box_id.includes(senderData.id.toString())) {
        console.log("🚀 ~ handleOnMessage ~ data:", data);
        const newMessage = JSON.parse(data?.message?.user_message_data || "{}");
        // Skip if message is from the current user to avoid duplication
        if (newMessage.message_by_id?.toString() === senderData.id.toString()) {
          console.log("Skipping message from current user:", newMessage);
          return;
        }
        const oldMsg = messageRef.current;
        const _msg = {
          id: data.message.id, // Use server-provided ID if available
          user_message_data: JSON.stringify(data?.message),
          created_at: data.message.created_at || new Date().toISOString(),
        };
        // Check for duplicates using message ID or message_time and message_by_id
        const isDuplicate = oldMsg.some(
          (msg: any) =>
            (msg.id && msg.id === _msg.id) ||
            (JSON.parse(msg.user_message_data).message_time === newMessage.message_time &&
              JSON.parse(msg.user_message_data).message_by_id === newMessage.message_by_id)
        );
        if (!isDuplicate) {
          setMessageBox([...oldMsg, _msg]); // Append to the end
        }
      }
    }
  };
  // useEffect(() => {
  //   if (isPrivateChat) getChat(roomId);
  //   setPreviousMessageCount(messageList.length);
  // }, [isPrivateChat, roomId, getChat, messageList]);

  const scrollToBottom = () => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messageList]);

  const getFileNameFromUrl = (name: string) => {
    var index = name.indexOf("%2F");
    var newVariable = name.substring(index + 3);
    return newVariable
  }

  useEffect(() => {
    setPreviousMessageBoxLength(messageBox.length);
    console.log("🚀 ~ handleOnMessage ~ messageBox:", messageBox);
  }, [messageBox]);

  const saveMessage = async (strMessageType: any, newMessage: any, room_id: any) => {
    let objBody = {
      type: strMessageType,
      session_map_id: session_id,
      room_id: room_id,
      message_by_id: parseInt(senderData?.id),
      message_to_id: receiverData?.id,
      user_message_data: JSON.stringify(newMessage),
    };
    try {
      const res: any = await dispatch(createChat(objBody));
      if (res && typeof res == "object") {
        let _msg = {
          type: "private_chat", //private_chat
          message: newMessage,
          room_id: room_id,
          sub_type: "individual",
          chat_box_id: room_id
        }
        userInfoHandler = validateAndCreateSocketIfExist(roomId, () => { }, socketList);
        userInfoHandler.sendMessage(JSON.stringify(_msg));


        return;
      }
    } catch (error) {
    }
  };

  const saveActions = async () => {
    const session = await axiosInstance.post("/trainee/live_session_plan_preview_trainee", {
      session_map_id: room_id
    });

    const responseData = session?.data?.responseData || {};
    const allActivities = [
      ...(responseData.prePlannedActivities || []),
      ...(responseData.quickSetupActivities || [])
    ];

    const launchData = allActivities.find((el: any) => el.status === "LAUNCH");
    if(!launchData?.id){
      return;
    }

    const engagementType = "L_CHAT"
    const obj = {
      engagementType,
      userId: userData?.id,
      sessionActivityExecutionLogId: launchData?.id,
      isRead: "NO",
      participantId: userData?.id,
      subType:  null
    }

    await axiosInstance.post("/session/save_session_actions_log", obj);
  }

  const handleSockets = async (msg: any, replyTo?: any) => {
    if (!msg.trim()) {
      return;
    }

    let room__id = room_id == undefined ? senderData?.id < receiverData?.id ? senderData?.id + "_" + receiverData?.id : receiverData?.id + "_" + senderData?.id : room_id;

    let _msgObj = {}

    if (replyTo && Object.keys(replyTo).length > 0) {
      var replyToz = {
        ...replyTo,
        message_by_id: parseInt(senderData?.id),
        id: replyTo?.message_by_id,
        type: "private_chat",
        room_id: room__id,
        message_by_type: null,
        created_at: moment(new Date()).format("hh:mm a"),
        session_map_id: session_id,
        user_message_data: JSON.stringify(replyTo)
      };
      _msgObj = {
        message: msg,
        message_by: senderData?.email,
        message_by_name: senderData?.name,
        message_by_id: senderData?.id,
        message_type: "text",
        message_to: sessionData?.trainer?.subscriber_id == receiverData?.id ? chatParticipantType?.TRAINER : chatParticipantType?.PARTICIPANT,
        message_to_id: replyTo?.message_by_id,
        message_time: moment(new Date()).format("hh:mm a"),
        message_reply_to: JSON.stringify(replyToz),
        sender_image: userData?.profileImage
      }
    }
    else {
      _msgObj = {
        message: msg,
        message_by: chatParticipantType?.PARTICIPANT,
        message_by_name: senderData?.name,
        message_by_id: senderData?.id,
        message_type: "text",
        message_to: sessionData?.trainer?.subscriber_id == receiverData?.id ? chatParticipantType?.TRAINER : chatParticipantType?.PARTICIPANT,
        message_to_id: receiverData?.id,
        message_time: moment(new Date()).format("hh:mm a"),
        message_reply_to: '',
        sender_image: user.profileImage
      };
    }
    saveMessage("private_chat", _msgObj, room__id);
    saveActions();
    userInfoHandler = validateAndCreateSocketIfExist(session_id, () => { }, socketList);
    userInfoHandler.sendMessage(
      JSON.stringify({
        type: "chat_message",
        message: _msgObj,
        room_id: session_id,
        sub_type: "individual",
        chat_box_id: room__id,
      })
    );
  };

  const renderChat = (message: any, index: number) => {
    // Safely parse user_message_data
    let _message;
    try {
      _message = JSON.parse(message?.user_message_data || '{}');
    } catch (error) {
      console.error('Error parsing user_message_data:', error, message);
      return null; // Skip rendering this message to avoid crashing
    }

    // Skip rendering if _message is invalid
    if (!_message || !_message.message) {
      return null;
    }
    // Determine if the message is sent by the current user
    const isSentByUser = _message?.message_by_id.toString() === senderData?.id.toString();

    // Handle reply messages
    if (_message?.message_reply_to && _message?.message_reply_to !== '') {
      let _replyTo;
      try {
        _replyTo = JSON.parse(_message?.message_reply_to);
      } catch (error) {
        console.error('Error parsing message_reply_to:', error);
        _replyTo = {};
      }
      const senderImage = _replyTo?.sender_image || _message?.sender_image || 'https://via.placeholder.com/40';

      return (
        <div
          key={index}
          className="flex flex-col w-[90%] mx-4 my-2 p-4 bg-white rounded-lg shadow-md"
        >
          {/* Reply message section */}
          <div className="flex items-center mb-2">
            <img
              src={senderImage !== 'null' ? senderImage : 'https://via.placeholder.com/40'}
              alt="avatar"
              className="w-10 h-10 rounded-full mr-2"
              onError={(e) => (e.currentTarget.src = 'https://via.placeholder.com/40')}
            />
            <span className="font-semibold text-gray-800">{_replyTo?.message_by_name || 'Unknown'}</span>
            <span className="text-gray-500 text-sm ml-auto">{_replyTo?.message_time}</span>
          </div>
          <div className="text-gray-700 mb-2">{_replyTo?.message || 'No reply content'}</div>

          {/* Current message section (in reply context) */}
          <div className="flex flex-col border-l-4 border-blue-500 pl-4 bg-gray-100 rounded-lg p-2">
            <div className="flex items-center mb-2">
              <img
                src={_message?.sender_image !== 'null' ? _message?.sender_image : 'https://via.placeholder.com/40'}
                alt="avatar"
                className="w-10 h-10 rounded-full mr-2"
                onError={(e) => (e.currentTarget.src = 'https://via.placeholder.com/40')}
              />
              <span className="font-semibold text-gray-800">{_message?.message_by_name || 'Unknown'}</span>
              <span className="text-gray-500 text-sm ml-auto">{_message?.message_time}</span>
            </div>
            {_message?.message.startsWith('https://') ? (
              <a
                href={_message?.message}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 underline"
              >
                {_message?.message.includes('.jpg') || _message?.message.includes('.png') ? (
                  <img
                    src={_message?.message}
                    alt="media"
                    className="w-[300px] h-auto rounded-lg"
                    onError={(e) => (e.currentTarget.src = 'https://via.placeholder.com/300')}
                  />
                ) : (
                  getFileNameFromUrl(_message?.message)
                )}
              </a>
            ) : (
              <div className="text-gray-700">{_message?.message}</div>
            )}
          </div>
        </div>
      );
    }

    // Regular message
    return (
      <div key={index} className="flex flex-col w-full px-4">
        {/* New Messages Divider */}
        {index === messageBox.length - 1 && messageBox.length > 0 && messageBox.length !== previousMessageBoxLength && (
          <div className="text-center text-gray-500 font-bold my-2">
            ---------------- New Messages ----------------
          </div>
        )}

        <div
          className={`flex flex-col w-[75%] p-4 my-2 mr-2 rounded-xl shadow-md bg-[#5B5D6B] ${isSentByUser ? 'self-end' : 'self-start'
            }`}
        >
          {_message?.message.startsWith('https://') ? (
            <a
              href={_message?.message}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 underline"
            >
              {_message?.message.includes('.jpg') || _message?.message.includes('.png') ? (
                <img
                  src={_message?.message}
                  alt="media"
                  className="w-[300px] h-auto rounded-lg"
                  onError={(e) => (e.currentTarget.src = 'https://via.placeholder.com/300')}
                />
              ) : (
                getFileNameFromUrl(_message?.message)
              )}
            </a>
          ) : (
            <div className="text-white text-sm">{_message?.message}</div>
          )}
          <div className="flex items-center mt-2">
            {isSentByUser ? (
              <>
                <span className="text-white justify-between border-t pt-[2%] mt-[2%] text-sm font-medium">{_message?.message_by_name || 'You'}</span>
                <span className="text-white justify-between border-t pt-[2%] mt-[2%] text-sm font-normal">{_message?.message_time}</span>
              </>
            ) : (
              <>
                <span className="text-white justify-between border-t pt-[2%] mt-[2%] text-sm font-medium">{_message?.message_by_name || 'Unknown'}</span>
                <span className="text-white justify-between border-t pt-[2%] mt-[2%] text-sm font-normal">{_message?.message_time}</span>
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={`flex flex-col h-screen py-[5%] bg-[#38393F] overflow-y-auto ${animate}`} ref={containerRef}>
      {messageBox.map((message: any, index: number) => renderChat(message, index))}
      <PrivateChatInput onMessage={handleSockets} />
    </div>
    // <div className={`flex flex-col h-screen py-[5%] bg-[#F1F3FF] overflow-y-auto ${animate}`} ref={containerRef}>
    //   {messageBox.length > 0 && messageBox[0]?.text?.length !== previousMessageCount && (
    //     <div className="text-center text-grey-500 font-bold my-2">---------------- New Messages ----------------</div>
    //   )}
    //   {messageBox
    //     .map((message, index) => (
    //       <MessageCard
    //         key={index}
    //         isReceived={message.author.id.toString() !== traineeId.toString()}
    //         message={message}
    //         isPrivateChat={isPrivateChat}
    //         setReplyTo={() => setReplyTo(message)}
    //       />
    //     ))}
    // </div>
  );
};

export default ChatArea;